import {DisableRuleSupplierActionEnum} from './disable-rule-supplier-action.enum';

//#region INTERFACE IStockItemRule

export interface IStockItemRule extends Object {
  digits: number;
  prefix: string;
  suffix: string;
  customPrefix?: string;
  customSuffix?: string;
}

//#endregion

//#region INTERFACE IOnHandEnableRule
export interface IOnHandEnableRule extends Object {
  descPrefix?: string;
  descPrefixArray?: string[];
  descSuffix?: string;
  descSuffixArray?: string[];
  lineColour?: number;
  onHoldCode?: number;
}

//#endregion

//#region INTERFACE IOnHandDisableRule
export interface IOnHandDisableRule extends Object {
  descPrefix?: string;
  descPrefixArray?: string[];
  descSuffix?: string;
  descSuffixArray?: string[];
  lineColour?: number;
  onHoldCode?: number;
  regularSuppCode?: string;
  supplierAction?: DisableRuleSupplierActionEnum;
}

//#endregion

//#region INTERFACE IAddItemRule
export interface IAddItemRule extends IStockItemRule {
  manualCodeEntryDefault?: boolean;
}

//#endregion

//#region INTERFACE IOnHandZeroDisableRule
export interface IOnHandZeroDisableRule extends IOnHandDisableRule, Object {
}

//#endregion

//#region INTERFACE IOnHandNotZeroDisableRule
export interface IOnHandNotZeroDisableRule extends IOnHandDisableRule, Object {
}

//#endregion

//#region INTERFACE IEnableStockItemRule
export interface IEnableStockItemRule extends IOnHandEnableRule, Object {
}

//#endregion

//#region INTERFACE IDisableStockItemRule
export interface IDisableStockItemRule extends Object {
  onHandNotZero: IOnHandNotZeroDisableRule;
  onHandZero: IOnHandZeroDisableRule;
}

//#endregion

//#region INTERFACE IDeletionStockItemRule
export interface IDeletionStockItemRule extends Object {
  onHandNotZero: IOnHandNotZeroDisableRule;
  onHandZero: IOnHandZeroDisableRule;
}

//#endregion

